import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";
import { Options } from "./SelectOptions";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    entranceDate: Date | null,
    fieldOfLocation: CheckboxField[],
    becomingAwareThrough: string,
    additionalNotes: string,
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
        
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    entranceDate: Date | null = null;
    becomingAwareThrough: string = "";
    additionalNotes: string = "";
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    fieldOfLocation: CheckboxField[] = Options.PreferredLocation.map((field) => {
        return new CheckboxField(field);
    });
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "entranceDate", value: this.entranceDate?.toString() ?? "" },
            { name: "fieldOfLocation", value: this.fieldOfLocation.filter((field) => field.value === true).map((field) => field.displayName).join(',')},
            { name: "becomingAwareThrough", value: this.becomingAwareThrough },
            { name: "additionalNotes", value: this.additionalNotes },
        );

        return application;
    }
}
